export default __webpack_public_path__ + "static/media/laptop3.2d938f76.jpg";